module.exports = {
  sanity: {
    projectId: process.env.SANITY_PROJECT_ID || '02a2vswy',
    dataset: process.env.SANITY_DATASET || 'production',
  },
};
